import {Tooltip} from 'flowbite';

export default (targetId, triggerId, placement) => {
  const $targetEl = document.getElementById(targetId);
  const $triggerEl = document.getElementById(triggerId);

  if ($targetEl === null || $triggerEl === null) {
    return {
      init() {
      },
      show() {
      },
      hide() {
      },
      toggle() {
      },
      destroy() {
      },
    };
  }

  const options = {
    placement: placement,
    triggerType: 'hover',
  };

  return new Tooltip($targetEl, $triggerEl, options);
};